<template>
	<el-form ref="editFormRef" :model="editForm" :rules="rules" :label-width="formLabelWidth" class="scm-user-form">
		<el-form-item label="原始密码" prop="OldPassword">
			<el-input v-model="editForm.OldPassword" type="password" placeholder="请输入原始密码" autocomplete="off" clearable />
			<span class="slot">当前用户的原始密码</span>
		</el-form-item>
		<el-form-item label="重设密码" prop="NewPassword">
			<el-input v-model="editForm.NewPassword" type="password" placeholder="请输入新的密码" autocomplete="off" clearable />
			<span class="slot">重写需设置新的密码</span>
		</el-form-item>
		<el-form-item label="再输一次" prop="NewPassword2">
			<el-input v-model="editForm.NewPassword2" type="password" placeholder="请再次输新密码" autocomplete="off" clearable />
			<span class="slot">与重设的密码需相同</span>
		</el-form-item>
	</el-form>
</template>

<script setup name="UserCenterModify">
import { resetForm } from '@/utils/index'

import { modifyPassword } from '@/api/security/manager'

const { proxy } = getCurrentInstance()

const formLabelWidth = ref('80px')

const data = reactive({
	editForm: {
		OldPassword: '',
		NewPassword: '',
		NewPassword2: ''
	},
	rules: {
		OldPassword: [
			{ required: true, message: '请输入原密码', trigger: 'blur' },
			{ min: 6, max: 50, message: '长度在 6 到 32 个字符', trigger: 'blur' }
		],
		NewPassword: [
			{ required: true, message: '请输入新密码', trigger: 'blur' },
			{ min: 6, max: 50, message: '长度在 6 到 32 个字符', trigger: 'blur' }
		],
		NewPassword2: [
			{ required: true, message: '请再输入一次新密码', trigger: 'blur' },
			{ min: 6, max: 50, message: '长度在 6 到 32 个字符', trigger: 'blur' }
		]
	}
})
const { editForm, rules } = toRefs(data)

/**
 * 修改保存
 */
function saveEditForm(onshow) {
	proxy.$refs['editFormRef'].validate((valid) => {
		if (valid) {
			const param = {
				oldpassword: editForm.value.OldPassword,
				password: editForm.value.NewPassword,
				password2: editForm.value.NewPassword2
			}
			modifyPassword(param).then((res) => {
				if (res && res.Success) {
					proxy.$modal.msgSuccess('恭喜你，改密成功！下次请用新密码登录.')
					resetForm(proxy,'editFormRef')
				} else {
					proxy.$modal.msgError(res.ErrMsg)
				}
			})
		} else {
			return false
		}
	})
}

// 子组件数据暴露给父组件
defineExpose({
	saveEditForm
})
</script>

<style scoped lang="scss">
.scm-user-form .el-input {
	width: 60% !important;
}
</style>
